import ApiService from "@/core/services/api.service";
// import { deepCopy } from "@/util/index.js";
// let Base64 = require('js-base64').Base64;
// action types
export const ADDTABLE = "addTable";
export const ADDFORM = "addForm";
export const DELETEtABLE = "deleteTable";
export const GETROLES = "getRoles";
export const USERS = "users";
export const MANAGEITEM="manageItem";//键值管理-查看
export const MANAGEITEMDELETE="manageItemDelete";//键值管理-删除
export const MANAGEITEMADD="manageItemAdd";//键值管理-新增
//mutations types
export const SETTABLE = "setTable";


const state = {
    tablesData: []
};


const actions = {
    // [CHANGE_MENUS]({ commit }) {
    //   commit(SET_CHANGE_MENUS, MENU);
    //   return MENU;
    // },
    [USERS]({ commit }, o) {
        console.log(commit)
        return ApiService.put(`/api-user/users`, o, { type: 'json' })
    },
    [GETROLES]() {
        return ApiService.get(`/api-user/roles`);
    },
    [DELETEtABLE]({ commit }, id) {
        console.log(commit)
        return ApiService.delete(`/api-config/web/DictType/remove/${id}`);
    },
    [ADDFORM]({ commit }, o) {
        console.log(commit)
        return ApiService.post(`/api-config/web/DictType/saveOrUpdate`, o, { type: 'json' })
    },
    [ADDTABLE]({ commit }, { page, limit, selectKey, selectValue }) {
        console.log(commit)
        return ApiService.get(`/api-config/web/DictType/QueryByPage?${selectKey}=${selectValue}&page=${page}&limit=${limit}`)
    },
    [MANAGEITEM]({ commit }, id) {
      console.log(commit,id)
      return ApiService.get(`/api-config/web/DictData/dictType/${id}`)
  },
[MANAGEITEMDELETE]({ commit }, id) {
  console.log(commit)
  return ApiService.delete(`/api-config/web/DictData/remove/${id}`)
},
[MANAGEITEMADD]({ commit }, o) {
  console.log(commit)
  return ApiService.post(`/api-config/web/DictData/saveOrUpdate`, o, { type: 'json' })
},

};
const mutations = {
    [SETTABLE](state, data) {
        state.tablesData = data;
    },

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
